import { render, staticRenderFns } from "./AccountHeader.vue?vue&type=template&id=74085210&scoped=true&"
import script from "./AccountHeader.vue?vue&type=script&lang=ts&"
export * from "./AccountHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74085210",
  null
  
)

export default component.exports